import { deserialize, serialize } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKReportSummary implements EntityAware {

    @serialize
    @deserialize
    public total_income: number = 0;

    @serialize
    @deserialize
    public total_expense: number = 0;

    @serialize
    @deserialize
    public balance: number = 0;
}
